
 function dateFormat(timestamp) {
    let d = new Date(timestamp);
    var year=d.getFullYear();
    var month=d.getMonth()+1;
    if(month < 10) {
        month = '0'+month;
    }
    var day=d.getDate();
    if(day < 10) {
        day = '0'+day;
    }
    var hour=d.getHours();
     if(hour < 10) {
         hour = '0'+hour;
     }
    var minute=d.getMinutes();
     if(minute < 10) {
         minute = '0'+minute;
     }
    var second=d.getSeconds();
     if(second < 10) {
         second = '0'+second;
     }
    return year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
}

 function dateFormat_date(timestamp) {
   let d = new Date(timestamp);
   var year=d.getFullYear();
   var month=d.getMonth()+1;
   if(month < 10) {
     month = '0'+month;
   }
   var day=d.getDate();
   if(day < 10) {
     day = '0'+day;
   }
   var hour=d.getHours();
   if(hour < 10) {
     hour = '0'+hour;
   }
   var minute=d.getMinutes();
   if(minute < 10) {
     minute = '0'+minute;
   }
   var second=d.getSeconds();
   if(second < 10) {
     second = '0'+second;
   }
   return year+'-'+month+'-'+day;
 }

 function monthFormat(val) {
    let year = parseInt(val/12);
    let month = val%12;

    if(val == 0) {
        return '永久';
    }
    if(month == 0) {
        return year+'年';
    }
    if(year == 0) {
        return month+'个月';
    }
    return year+'年'+month+'个月';
 }
  function compareTime(a,b) {
    var start = new Date(a);
    var starts = start.getTime();
    var end = new Date(b);
    var ends = end.getTime();
    var weekDay = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    if (starts > ends) {
      return 1;
    }
    if (starts == ends) {
      return 0;
    }
    return -1;
  }
export {
    dateFormat,
    monthFormat,
    dateFormat_date,
    compareTime,
};
